import { keyframes } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';

/** Cycles "", ".", "..", "..." for the trailing animated ellipsis. */
const ellipsisCycle = keyframes`
  0%   { content: ''; }
  25%  { content: '.'; }
  50%  { content: '..'; }
  75%  { content: '...'; }
  100% { content: '...'; }
`;

/**
 * Styles for the chat-thread "Thinking…" status indicator.
 *
 * The label is the localized "Thinking" word with the trailing
 * ellipsis appended as animated `::after` content. Reserving a fixed
 * em width on the pseudo-element keeps the label from jittering as
 * the dots cycle, and `prefers-reduced-motion: reduce` collapses the
 * animation to a static "…".
 */
const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.new.color.textSecondary,
    ...theme.typography.small_body_regular,
    lineHeight: 1.6,
  },
  text: {
    margin: 0,
    '&::after': {
      content: '""',
      display: 'inline-block',
      width: '1.25em',
      textAlign: 'left',
      animation: `${ellipsisCycle} 1.2s steps(1, end) infinite`,
    },
    '@media (prefers-reduced-motion: reduce)': {
      '&::after': {
        animation: 'none',
        content: '"…"',
        width: 'auto',
      },
    },
  },
}));

export default useStyles;
